import moment from "moment";
import { SENTIMENT_ACTION } from "./actions";
import { IData } from "../web/common";
import klineInterval from "../Params";

const DATA_COUNT = 50;
const COLLECTION_NAME = "NS_CRP_SIGNALS_500";

interface IXUData {
  signal500: { Basket: string[]; Outgoing: []; Incoming: []; Index: number };
  requested: boolean;
  loaded: boolean;
}

const initialState: IXUData = {
  signal500: {} as any,
  requested: false,
  loaded: false,
};

export function loadSignal500(firebase: any, period: number) {
  if (period < 0 || ![0, 10, 30, 99].includes(period)) {
    console.log("Invalid period for signal 500. Period:", period);
    return async function thunk(dispatch: any, getState: any) {
      dispatch({
        type: SENTIMENT_ACTION.EMPTY_ACTION,
        payload: {},
      });
    };
  }
  return async function thunk(dispatch: any, getState: any) {
    const state = getState();
    if (state.Signal500.requested) return;
    dispatch({
      type: SENTIMENT_ACTION.SIGNAL_500,
      payload: { requested: true, loaded: false, sentiment: [] },
    });

    let ix = 0;
    firebase
      .firestore()
      .collection(`${COLLECTION_NAME}${klineInterval}_P${period}`)
      .where("reverse", "==", 0)
      .orderBy("dateTime", "desc")
      .limit(DATA_COUNT)
      .onSnapshot((querySnapshot: any) => {
        let signal500Data: Object[] = [];
        querySnapshot.forEach(function (doc: any) {
          const dateVal = moment
            .unix(doc.data().dateTime.seconds)
            .format("YYYY/MM/DD");

          signal500Data.push({
            key: ix++,
            name: "signal",
            Basket: doc.data().basket ?? [],
            Outgoing: doc.data().outgoing ?? [],
            Index: doc.data().index,
            Incoming: doc.data().incoming ?? [],
            Time: doc.data().time ?? 0,
            Date: moment(doc.data().dateTime.toDate())
            //.zone(0)
            .format("DD.MM.YY HH:mm")
          });
        });

        dispatch({
          type: SENTIMENT_ACTION.SIGNAL_500,
          payload: {
            signal500: signal500Data,
            loaded: true,
            requested: true,
          },
        });
      });
  };
}

export default function Signal500(state = initialState, action: any) {
  switch (action.type) {
    case SENTIMENT_ACTION.SIGNAL_500:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
export const signal500Selector = (state: any) => state.Signal500;
